import { render, staticRenderFns } from "./DdFooterButton.vue?vue&type=template&id=41204ba0&scoped=true&"
import script from "./DdFooterButton.vue?vue&type=script&lang=js&"
export * from "./DdFooterButton.vue?vue&type=script&lang=js&"
import style0 from "./DdFooterButton.vue?vue&type=style&index=0&id=41204ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41204ba0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VTooltip})
